






import { Vue, Component } from 'vue-property-decorator'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'

dayjs.locale('ja')

@Component
export default class App extends Vue {}
